import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

export const greetingFor = (h) => (h >= 5 && h < 12 ? "Good morning" : h >= 12 && h < 17 ? "Good afternoon" : "Good evening");

export const Greeting = ({ light }) => {
  const { user } = useAuth();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(t); }, []);
  if (!user) return null;
  const name = user?.name?.trim() || user?.email?.split("@")[0] || "";
  return <p className={`rise-in ${light ? "text-xl text-indigo-100 sm:text-3xl" : "text-sm text-slate-500 sm:text-[15px]"}`} data-testid="greeting">{greetingFor(now.getHours())}, <span className={light ? "font-bold text-white" : "font-medium text-slate-800"}>{name}</span></p>;
};
